import React, { useState, useEffect } from 'react';
import * as styles from '../style';
import { FormGroup } from '../../../../styles/customComponents';
import { DebounceInput } from 'react-debounce-input';
import { GRAY_DARKER } from '../../../../styles/variables';
import { CloseIcon } from '../../../../components/Icons';
import SelectList from '../../../../components/SelectList';
import { formatSearchProductsList, filterSearchProducts } from '../../../../helpers/products';

const SearchProduct = ({ categories, filterCategories }) => {
  const [searchProductsList, setSearchProductsList] = useState([]);
  const [entitiesList, setEntitiesList] = useState([]);
  const [isDropDownOpen, toggleDropDown] = useState(false);
  const [searchText, setSearchText] = useState('');
  const [wrapperRef, setWrapperRef] = useState('');

  useEffect(() => {
    setEntitiesList(formatSearchProductsList(categories));
    if (searchText) {
      onChange(searchText, false);
    }
  }, [categories]);

  const onChange = (text, toggleSearchList = true) => {
    setSearchText(text);
    const regWhiteSpace = new RegExp(/\S/);
    if (text.length >= 3 && regWhiteSpace.test(text)) {
      const filteredList = entitiesList
        .filter(product => product.name.toLocaleLowerCase().indexOf(text.toLocaleLowerCase()) > -1)
        .sort((a, b) => a.name.localeCompare(b.name, 'pt-BR', { sensitivity: 'base' }));
      setSearchProductsList(filteredList);
      filterCategories({
        categories: filterSearchProducts(categories, filteredList),
        qtdFiltered: filteredList.length,
        textSearched: text,
      });
      toggleDropDown(toggleSearchList);
    } else {
      setSearchProductsList([]);
      filterCategories({
        categories: [],
        qtdFiltered: 0,
        textSearched: '',
      });
      toggleDropDown(false);
    }
  };

  const onSelect = data => {
    if (data) {
      onChange(data.name);
    }
    toggleDropDown(false);
  };

  const onFocusSearch = () => {
    if (searchProductsList.length) {
      toggleDropDown(true);
    }
  };

  return (
    <styles.SearchProduct ref={node => setWrapperRef(node)} show-search-icon={!searchText.length}>
      <FormGroup styles={{ display: 'flex', 'flex-direction': 'column' }}>
        <label htmlFor="input-search-product">Busca</label>
        <styles.DivSearchInput>
          <DebounceInput
            id="input-search-product"
            name="searchText"
            onFocus={onFocusSearch}
            type="text"
            placeholder="Pesquisar produto ou categoria"
            value={searchText}
            onChange={e => onChange(e.target.value)}
            debounceTimeout={10}
          />
          {searchText.length > 0 && (
            <styles.CloseContainer onClick={() => onChange('')}>
              <CloseIcon color={GRAY_DARKER} size="17px" />
            </styles.CloseContainer>
          )}
        </styles.DivSearchInput>
      </FormGroup>
      {searchProductsList.length > 0 && (
        <SelectList
          list={searchProductsList}
          onSelect={onSelect}
          hightlight={searchText}
          isDroppedDown={isDropDownOpen}
          showSelected={false}
          wrapperRef={wrapperRef}
        />
      )}
    </styles.SearchProduct>
  );
};

export default SearchProduct;



// WEBPACK FOOTER //
// ./src/screens/Product/ProductsSecondaryActions/SearchProduct/index.js